module.exports = __webpack_public_path__ + "media/images/samples/home/top-n-2-341bde208727764b059c5e538e758687.png";